import { LOGIN_PATH } from '@/constants/login';
import { SIGNUP_PATH } from '@/constants/signup';
import type { PublicFooterColumn, PublicNavLink } from '@/types/publicPages';

// Herkese açık sayfaların (Hakkımızda, Gizlilik, Kullanım Şartları, İade, Mesafeli Satış, Fiyatlandırma) üst menüsü.
// labelKey: tam çeviri anahtarı. "to" uygulama içi rota, "href" anasayfa çapası.
export const PUBLIC_NAV_LINKS: PublicNavLink[] = [
  { labelKey: 'publicPages.layout.navFeatures', href: '/#features' },
  { labelKey: 'publicPages.layout.navPricing', to: '/pricing' },
  { labelKey: 'publicPages.layout.navContact', href: '/#contact' },
  { labelKey: 'publicPages.layout.navPrivacy', to: '/privacy' },
  { labelKey: 'publicPages.layout.navTerms', to: '/terms-and-conditions' },
];

// Herkese açık sayfaların footer sütunları (labelKey/titleKey: tam çeviri anahtarı).
export const PUBLIC_FOOTER_COLUMNS: PublicFooterColumn[] = [
  {
    titleKey: 'publicPages.footer.cols.about.title',
    links: [
      { labelKey: 'publicPages.footer.cols.about.links.about', to: '/about' },
      { labelKey: 'publicPages.footer.cols.about.links.pricing', to: '/pricing' },
    ],
  },
  {
    titleKey: 'publicPages.footer.cols.legal.title',
    links: [
      { labelKey: 'publicPages.footer.cols.legal.links.privacy', to: '/privacy' },
      { labelKey: 'publicPages.footer.cols.legal.links.terms', to: '/terms-and-conditions' },
      { labelKey: 'publicPages.footer.cols.legal.links.refund', to: '/refund' },
      { labelKey: 'publicPages.footer.cols.legal.links.distanceSales', to: '/distance-sales' },
    ],
  },
];

// Peoply Kariyer'in kendi domaininde (JOBS_SITE_URL) aynı sayfaların üst menüsü ve footer sütunları: Peoply'nin
// firma sayfaları (özellikler, fiyatlandırma, iade, mesafeli satış) yerine o domainin kendi sayfaları. Hepsi
// kariyer domaininde açılır; Peoply'e link yok. "#nasil-calisir": ilan listesinin "Nasıl çalışır?" bölümü
// (careers/constants JOBS_HOW_IT_WORKS_ID).
export const CAREERS_SITE_ABOUT_PATH = '/about';
export const CAREERS_SITE_NAV_LINKS: PublicNavLink[] = [
  { labelKey: 'publicPages.careers.nav.jobs', to: '/' },
  { labelKey: 'publicPages.careers.nav.howItWorks', href: '/#nasil-calisir' },
  { labelKey: 'publicPages.layout.navAbout', to: CAREERS_SITE_ABOUT_PATH },
  { labelKey: 'publicPages.layout.navPrivacy', to: '/privacy' },
  { labelKey: 'publicPages.layout.navTerms', to: '/terms-and-conditions' },
];
export const CAREERS_SITE_FOOTER_COLUMNS: PublicFooterColumn[] = [
  {
    titleKey: 'publicPages.careers.footer.colTitle',
    links: [
      { labelKey: 'publicPages.careers.footer.links.jobs', to: '/' },
      { labelKey: 'publicPages.careers.footer.links.howItWorks', href: '/#nasil-calisir' },
      { labelKey: 'publicPages.careers.footer.links.login', to: LOGIN_PATH },
      { labelKey: 'publicPages.careers.footer.links.signup', to: SIGNUP_PATH },
    ],
  },
  {
    titleKey: 'publicPages.footer.cols.about.title',
    links: [{ labelKey: 'publicPages.footer.cols.about.links.about', to: CAREERS_SITE_ABOUT_PATH }],
  },
  {
    titleKey: 'publicPages.footer.cols.legal.title',
    links: [
      { labelKey: 'publicPages.footer.cols.legal.links.privacy', to: '/privacy' },
      { labelKey: 'publicPages.footer.cols.legal.links.terms', to: '/terms-and-conditions' },
    ],
  },
];

export const PUBLIC_CONTACT_HREF = '/#contact';

// Fiyatlandırma planları (publicPages.pricing.plans.<anahtar>) ve öne çıkan plan.
export const PRICING_PLAN_KEYS = ['starter', 'growth', 'enterprise'] as const;
export const PRICING_HIGHLIGHTED_PLAN: (typeof PRICING_PLAN_KEYS)[number] = 'growth';
